/* ==========================================================================
   Nicosé Chatbot — lógica del asistente guiado por botones (sin backend, sin IA)
   --------------------------------------------------------------------------
   PARA EDITAR CONTENIDO: modifica el objeto FLOWS más abajo.
   - texto del flujo .......... flow.text
   - botones del flujo ........ flow.options[]
       { label, goto }                  -> navega a otro flujo
       { label, menu: true }            -> vuelve al menú principal
       { label, url }                   -> abre un enlace del sitio
       { label, wa: "mensaje..." }      -> abre WhatsApp con texto prellenado
   El número de WhatsApp y las URLs llegan desde el snippet (data-* attrs),
   así que NO se tocan acá. Cambiar el número en snippets/nicose-chatbot.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('nicose-chatbot');
  if (!root) return;

  var WA_NUMBER = root.dataset.waNumber || '';
  var URL_STOCK = root.dataset.urlStock || '/collections/all';
  var URL_TALLA = root.dataset.urlTalla || '/pages/recomendador-de-talla';
  var URL_ESTADO = root.dataset.urlEstado || '/pages/estado-de-fabricacion';

  // --- Definición de flujos (100% editable) --------------------------------
  var FLOWS = {
    menu: {
      text: 'Hola 💖 Soy el asistente de Nicosé. Te ayudo a revisar stock, elegir talla, ver precios o diseñar tu top.',
      options: [
        { label: '🛍️ Ver tops disponibles ahora', goto: 'stock', primary: true },
        { label: '📏 Guía de tallas', goto: 'talla' },
        { label: '💲 Ver precios', goto: 'precios' },
        { label: '🎨 Diseñar top personalizado', goto: 'personalizado' },
        { label: 'Más opciones', goto: 'mas_opciones', secondary: true },
        { label: 'Hablar por WhatsApp', wa: 'Hola Nicosé, necesito ayuda con una consulta.', track: 'whatsapp', waFinal: true }
      ]
    },

    mas_opciones: {
      track: 'mas_opciones',
      text: 'También puedo ayudarte con envíos, plazos o seguimiento de pedido.',
      options: [
        { label: '🚚 Envíos y plazos', goto: 'envios' },
        { label: '📦 Seguimiento de pedido', goto: 'seguimiento' },
        { label: '🛍️ Ver tops disponibles ahora', goto: 'stock' },
        { label: 'Hablar por WhatsApp', wa: 'Hola Nicosé, necesito ayuda con una consulta.', track: 'whatsapp', waFinal: true },
        { label: '← Volver al menú', menu: true }
      ]
    },

    precios: {
      track: 'precios',
      text: 'Nuestros tops clínicos personalizados tienen estos valores:\n\n• Hasta XL: $30.000\n• 2XL a 3XL: $32.000\n• 4XL a 5XL: $36.000\n\nEl tiempo de confección es de 15 días hábiles desde que ingresa al taller.',
      options: [
        { label: '🎨 Diseñar top personalizado', goto: 'personalizado' },
        { label: '📏 Guía de tallas', goto: 'talla' },
        { label: 'Hablar por WhatsApp', wa: 'Hola Nicosé, necesito ayuda con una consulta.', track: 'whatsapp' },
        { label: '← Volver al menú', menu: true }
      ]
    },

    talla: {
      track: 'talla',
      text: 'Para ayudarte con la talla, revisa tu contorno de busto y compáralo con nuestra guía de medidas. Si estás entre dos tallas, recomendamos elegir la talla mayor para mayor comodidad, especialmente si prefieres que el top no quede ajustado.\n\nTambién puedes usar el recomendador de tallas en nicose.cl 👇',
      options: [
        { label: '📏 Abrir recomendador de tallas', url: URL_TALLA },
        { label: '💲 Ver precios', goto: 'precios' },
        { label: '🎨 Diseñar top personalizado', goto: 'personalizado' },
        { label: 'Hablar por WhatsApp sobre mi talla', wa: 'Hola Nicosé, necesito ayuda para elegir mi talla.', track: 'whatsapp' },
        { label: '← Volver al menú', menu: true }
      ]
    },

    personalizado: {
      track: 'personalizado',
      text: 'Perfecto 💖 Para encargar un personalizado necesitamos:\n\n1. Color base del top\n2. Diseño, personaje o temática\n3. Imagen de referencia si tienes\n4. Talla\n\nLos personalizados tienen un tiempo de confección de 15 días hábiles desde que ingresan al taller.',
      options: [
        { label: '💲 Ver precios', goto: 'precios' },
        { label: '📏 Guía de tallas', goto: 'talla' },
        { label: 'Enviar datos por WhatsApp', wa: 'Hola Nicosé, quiero un top personalizado. Mi talla es: __. Color base: __. Diseño/temática: __.', track: 'whatsapp' },
        { label: '← Volver al menú', menu: true }
      ]
    },

    envios: {
      track: 'envios',
      text: 'Los tops personalizados tienen un tiempo de confección de 15 días hábiles desde que ingresan al taller. El envío se calcula aparte según comuna o región.\n\nSi necesitas tu pedido para una fecha específica, escríbenos por WhatsApp antes de comprar para revisar si alcanzamos a gestionarlo.',
      options: [
        { label: 'Consultar envío por WhatsApp', wa: 'Hola Nicosé, quiero consultar por envío. Mi comuna/región es: __.', track: 'whatsapp' },
        { label: '💲 Ver precios', goto: 'precios' },
        { label: '🎨 Diseñar top personalizado', goto: 'personalizado' },
        { label: '← Volver al menú', menu: true }
      ]
    },

    stock: {
      track: 'stock',
      text: 'Puedes revisar los tops disponibles para despacho rápido. Si buscas una talla o diseño específico, escríbenos por WhatsApp y confirmamos disponibilidad.',
      options: [
        { label: '🛍️ Ver tops disponibles ahora', url: URL_STOCK },
        { label: 'Hablar por WhatsApp', wa: 'Hola Nicosé, quiero consultar disponibilidad de stock.', track: 'whatsapp' },
        { label: '🎨 Diseñar top personalizado', goto: 'personalizado' },
        { label: '← Volver al menú', menu: true }
      ]
    },

    seguimiento: {
      track: 'seguimiento',
      text: 'Si ya hiciste un pedido, podemos ayudarte a revisar el estado. Ten a mano tu nombre o número de pedido.',
      options: [
        { label: 'Consultar por WhatsApp', wa: 'Hola Nicosé, quiero consultar por el estado de mi pedido. Mi nombre es: __. Número de pedido si lo tengo: __.', track: 'whatsapp' },
        { label: '📦 Ver estado de fabricación', url: URL_ESTADO },
        { label: '← Volver al menú', menu: true }
      ]
    }
  };

  // --- Tracking hook (preparado, sin GA4/Pixel todavía) --------------------
  function track(name) {
    if (!name) return;
    // GA4: evento custom 'nicose_chatbot' con parámetro 'step'.
    // El gtag base se carga desde snippets/nicose-chatbot.liquid.
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'nicose_chatbot', { step: name });
    }
    // Fallback dataLayer (por si más adelante se usa GTM):
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'nicose_chatbot', step: name });
    }
  }

  // --- Render --------------------------------------------------------------
  var panel = root.querySelector('.nicose-chatbot__panel');
  var bodyEl = root.querySelector('.nicose-chatbot__body');
  var launcher = root.querySelector('.nicose-chatbot__launcher');
  var closeBtn = root.querySelector('.nicose-chatbot__close');
  var rendered = false;

  function waLink(message) {
    return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(message);
  }

  function renderFlow(id) {
    var flow = FLOWS[id];
    if (!flow) return;
    track(flow.track);

    var msg = document.createElement('div');
    msg.className = 'nicose-chatbot__msg';
    msg.textContent = flow.text;
    bodyEl.appendChild(msg);

    var opts = document.createElement('div');
    opts.className = 'nicose-chatbot__options';

    flow.options.forEach(function (o) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = o.label;

      var classes = ['nicose-chatbot__opt'];

      if (o.wa) classes.push('nicose-chatbot__opt--wa');
      if (o.waFinal) classes.push('nicose-chatbot__opt--wa-final');
      if (o.primary) classes.push('nicose-chatbot__opt--primary');
      if (o.secondary) classes.push('nicose-chatbot__opt--secondary');
      if (o.menu || /Volver al menú/i.test(o.label)) classes.push('nicose-chatbot__opt--back');

      btn.className = classes.join(' ');

      btn.addEventListener('click', function () {
        if (o.track) track(o.track);
        if (o.wa) {
          window.open(waLink(o.wa), '_blank', 'noopener');
        } else if (o.url) {
          window.location.href = o.url;
        } else if (o.menu) {
          resetTo('menu');
        } else if (o.goto) {
          renderFlow(o.goto);
          scrollDown();
        }
      });
      opts.appendChild(btn);
    });

    bodyEl.appendChild(opts);
    scrollDown();
  }

  function scrollDown() {
    requestAnimationFrame(function () {
      bodyEl.scrollTop = bodyEl.scrollHeight;
    });
  }

  function resetTo(id) {
    bodyEl.innerHTML = '';
    renderFlow(id);
  }

  // --- Abrir / cerrar ------------------------------------------------------
  function open() {
    if (!rendered) { renderFlow('menu'); rendered = true; }
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    track('open');
    setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 220);
  }

  function close() {
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    launcher.focus();
  }

  launcher.addEventListener('click', function () {
    root.classList.contains('is-open') ? close() : open();
  });
  closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });
})();
